<template>
  <div>
    <div class="country-select" @click="modalOpen = true">
      <country-flag :country="isoCountry" size="normal" />
    </div>
    <!-- <ion-item>
      <ion-label position="floating"> {{ $t("bookings.country") }} </ion-label>
      <ion-input @click="modalOpen = true" v-model="value" :readonly="true"></ion-input>
    </ion-item> -->
    <ion-modal
      :is-open="modalOpen"
      :swipe-to-close="true"
      :presenting-element="$parent.$refs.ionRouterOutlet"
    >
      <ion-page>
        <ion-header>
          <ion-toolbar>
            <ion-title>{{ $t("bookings.countrySelect") }}</ion-title>
          </ion-toolbar>
          <ion-toolbar>
            <ion-searchbar placeholder="Cerca" v-model="query"></ion-searchbar>
          </ion-toolbar>
        </ion-header>
        <ion-content>
          <ion-list>
            <ion-item
              @click="selectCountry(item)"
              v-for="item of filteredItems"
              :key="item.id"
            >
              <ion-label class="label"><country-flag :country="item.iso_3166_1_alpha2" size="normal" /> {{ item.native_name }}</ion-label>
            </ion-item>
          </ion-list>
        </ion-content>
      </ion-page>
    </ion-modal>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import axios from "axios";
import {
  IonInput,
  IonModal,
  IonPage,
  IonHeader,
  IonToolbar,
  IonSearchbar,
} from "@ionic/vue";
import CountryFlag from "vue-country-flag-next";

export default defineComponent({
  props: {
    modelValue: {
      required: false,
      type: Array,
    },
  },
  components: {
    // IonInput,
    IonModal,
    IonPage,
    IonHeader,
    IonToolbar,
    IonSearchbar,
    CountryFlag
  },
  data: () => ({
    modalOpen: false,
    value: null,
    items: [],
    query: "",
    isoCountry: null
  }),
  watch: {
    value: {
      deep: false,
      handler(newVal) {
        //this.$emit("update:modelValue", newVal);
      },
    },
  },
  beforeMount() {
    this.getCountries();
    //this.baseURL = axios.defaults.baseURL;
  },
  methods: {
    selectCountry(country) {
      this.value = country.iso_3166_1_alpha2;
      this.$emit("update:modelValue", country.iso_3166_1_alpha2);
      this.isoCountry = country.iso_3166_1_alpha2;
      this.modalOpen = false;
    },
    getCountries() {
      axios.get("/countries").then((resp) => {
        this.items = resp.data;
        this.selectCountry(this.items[0]);
      });
    },
  },
  computed: {
    filteredItems() {
      return this.items.filter((item) => {
        return item.native_name
          .toLowerCase()
          .includes(this.query.toLowerCase());
      });
    },
  },
});
</script>

<style lang="scss">
.label {
  display: flex !important;
    align-items: center;
    .normal-flag {
      margin-right: 6px;
    }
}
</style>
